module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "note"
  }, [_c('div', {
    staticClass: "notification cf-notification",
    class: _vm.levelClass
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.message) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-d26b3cea"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notify.vue
// module id = 1087
// module chunks = 0